module.exports = __webpack_public_path__ + "img/image1.73f5eeb5.png";